module.exports = __webpack_public_path__ + "static/media/linux-lads_shells.7d8d9393.png";